export default __webpack_public_path__ + "assets/models/d756926bf1fb064b9305ee7a00b9699a.glb";